import {atom} from 'jotai'

export const organizationBankAccountsState = atom(null)
